import React from "react";
import BasicInfoSectionProps from "./props";
import "./styles.scss";

function BasicInfoSection(props: BasicInfoSectionProps) {
  const { title, price, location, dealer } = props;

  return (
    <div className="basic-info-section">
      <h1 className="basic-info-section__title">{title}</h1>

      <div className="basic-info-section__price-container">
        <div className="basic-info-section__price-container-main">
          <span className="basic-info-section__price-amount">
            {price.amount}
          </span>
          {price.drop && (
            <span className="basic-info-section__price-drop">
              <span>↓</span>{price.drop}
            </span>
          )}
        </div>

        {(price.local || price.tax) && (<div className="basic-info-section__price-container-local-tax">
          {price.local && (
            <span className="basic-info-section__price-local"><span className="basic-info-section__price-dot">•</span>{price.local}</span>
          )}
          {price.tax && (
            <span className="basic-info-section__price-tax"><span className="basic-info-section__price-dot">•</span>{price.tax}</span>
          )}
         </div>)}
      </div>

      <div className="basic-info-section__location">{location}</div>
      <div className="basic-info-section__dealer">{dealer}</div>
    </div>
  );
}

export default React.memo(BasicInfoSection);
